import Immutable from 'seamless-immutable';
import _ from 'lodash';
import RefDataModel from './ref-data-model';
import { baseCollection } from '../common/collections';
import { valuesDeep } from '../common/tools';

/**
 * Transforms and array of refData objects into a RefDataCollection
 * @param {Object[]} refData - formatted refDatas
 * @returns {RefData[]}
 */
function create(refData = []) {
  return Immutable(_.map(refData, RefDataModel.create));
}

/**
 * Takes an array of ref data IDs or an object of IDs (e.g. all ids for a "category" or "scope") and returns a RefDataCollection made up of the specified ids
 * @param {string[]|object} ids - the ids of any ref data
 * @returns {RefData[]}
 */
const memoizedHydrateAll = () => {
  const _cache = {};
  let _key, _items;
  return ids => {
    const _ids = _.isArray(ids) ? ids : valuesDeep(ids);

    // create a key for our cache
    _key = JSON.stringify(_ids);

    // if the key already exists...
    if (_cache[_key]) return _cache[_key];
    else {
      // hydrate the models for each id
      _items = Immutable(_.map(_ids, id => RefDataModel.hydrate(id)));

      // create a new cache key
      _cache[_key] = _items;
      return _items;
    }
  };
};

const hydrateAll = memoizedHydrateAll();

export default {
  ...baseCollection,
  create,
  hydrateAll,
};
